import React from "react";
import { BarChart3 } from "lucide-react";

// ─── Design Tokens ───
const T = {
  bg: "#06060b", card: "#161624", border: "#1e1e35",
  text: "#eeeef5", muted: "#6b6b8a", dim: "#3d3d5c",
  accent: "#ff6b35", accentGlow: "rgba(255,107,53,0.15)",
};

// 營收分析 — empty state until an account-scoped ad-revenue endpoint exists.
//
// This page previously rendered generated demo data (random impressions,
// platform net profit, other venues and advertiser brands). It must not call
// /api/v1/analytics: that endpoint is platform-wide and admin-only. Platform-
// level metrics (平台淨利, network-wide venue/campaign counts) are never shown
// to venue accounts.
export default function AnalyticsDashboard() {
  return (
    <div style={{ background: T.bg, minHeight: "100vh", color: T.text, fontFamily: "'Noto Sans TC', 'SF Pro Display', -apple-system, sans-serif" }}>
      {/* ─── Header ─── */}
      <div style={{ padding: "28px 32px 0" }}>
        <h1 style={{ fontSize: 26, fontWeight: 900, margin: 0, letterSpacing: -0.3 }}>廣告收益</h1>
      </div>

      {/* ─── Empty state ─── */}
      <div style={{ padding: "24px 32px 32px" }}>
        <div role="status" style={{
          background: T.card, border: `1px solid ${T.border}`, borderRadius: 16,
          padding: "56px 24px", textAlign: "center",
        }}>
          <div style={{ width: 52, height: 52, borderRadius: 14, background: T.accentGlow, display: "inline-flex", alignItems: "center", justifyContent: "center", marginBottom: 16 }}>
            <BarChart3 size={24} color={T.accent} />
          </div>
          <div style={{ fontSize: 18, fontWeight: 700 }}>尚無廣告收益資料</div>
          <div style={{ fontSize: 13, color: T.muted, marginTop: 8, lineHeight: 1.7 }}>
            您的場域螢幕開始播放廣告後，曝光與收益將顯示於此。
          </div>
        </div>
      </div>
    </div>
  );
}
